import axios from 'axios';
import Cookies from 'js-cookie';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from cookies
    const token = Cookies.get('authToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common error cases
    if (error.response) {
      const { status, data } = error.response;

      // Log error in development
      if (import.meta.env.DEV) {
        console.error('❌ API Error Response:', {
          status,
          url: error.config?.url,
          data,
        });
      }

      // Handle specific status codes
      switch (status) {
        case 401:
          // Unauthorized - clear auth cookies and redirect to login
          Cookies.remove('authToken');
          Cookies.remove('refreshToken');
          Cookies.remove('user');
          Cookies.remove('company');
          
          // Only redirect if not already on sign-in page
          if (!window.location.pathname.includes('/sign-in') && 
              !window.location.pathname.includes('/sign-up')) {
            // Use setTimeout to avoid redirect during render
            setTimeout(() => {
              window.location.href = '/sign-in';
            }, 100);
          }
          break;

        case 403:
          // Forbidden
          console.error('Access forbidden');
          break;

        case 404:
          // Not found
          console.error('Resource not found');
          break;

        case 500:
          // Server error
          console.error('Internal server error');
          break;

        default:
          console.error('API Error:', data?.message || 'Unknown error');
      }

      // Return a more user-friendly error message
      const errorMessage =
        data?.message || `Request failed with status ${status}`;
      return Promise.reject(new Error(errorMessage));
    }

    // Network error or other issues
    if (error.request) {
      console.error('❌ Network Error:', error.message);
      return Promise.reject(
        new Error('Network error. Please check your connection.')
      );
    }

    // Other errors
    console.error('❌ Error:', error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
